// mappings "machine value": i18n-key

/** EVENT TYPES */

const EVENT_TYPE_KEY = {
  'Vaccination': 'eventTypes.vaccination',
  'Anti-Parasitic': 'eventTypes.antiParasitic',
  'Vet Visit': 'eventTypes.vetVisit',
  'Grooming': 'eventTypes.grooming',
  'Medicine': 'eventTypes.medicine',
  'Other': 'eventTypes.other',
};

export const getEventTypeLabel = (type, t) => {
  if (!type) return '';
  // If it's a standard type, use translation
  if (EVENT_TYPE_KEY[type]) {
    return t(EVENT_TYPE_KEY[type]);
  }
  // Otherwise, it's a custom type - return as is
  return type;
};

/**
 * Подпись типа события: сначала labels из каталога eventTypes, иначе i18n/строка как раньше.
 */
export const getEventTypeLabelFromCatalog = (type, t, globalEventTypes, i18n) => {
  if (!type) return '';
  const lang = (i18n?.language || i18n?.resolvedLanguage || 'en').split('-')[0];
  const cfg = Array.isArray(globalEventTypes)
    ? globalEventTypes.find((e) => e.key === type)
    : null;
  if (cfg?.labels && typeof cfg.labels === 'object') {
    const lbl = pickLang(cfg.labels, lang);
    if (lbl) return lbl;
  }
  return getEventTypeLabel(type, t);
};


/** REPEAT TYPES */

const REPEAT_TYPE_KEY = {
  'Never': 'repeatOptions.never',
  'Daily': 'repeatOptions.daily',
  'Weekly': 'repeatOptions.weekly',
  'Monthly': 'repeatOptions.monthly',
  'Every 4 month': 'repeatOptions.every4m',
  'Every 6 month': 'repeatOptions.every6m',
  'Yearly': 'repeatOptions.yearly',
  'Custom': 'repeatOptions.custom',
};

export const getRepeatTypeLabel = (type, t) =>
  type ? t(REPEAT_TYPE_KEY[type] || 'repeat.choose', type) : t('repeat.choose');


/** REMIND TYPES */

const REMIND_TYPE_KEY = {
  'As scheduled': 'remindOptions.asScheduled',
  'Never': 'remindOptions.never',
  '1 hour before': 'remindOptions.hour1',
  '1 day before': 'remindOptions.day1',
  '1 week before': 'remindOptions.week1',
  'Custom': 'remindOptions.custom',
};

export const getRemindTypeLabel = (type, t) =>
  type ? t(REMIND_TYPE_KEY[type] || 'remind.choose', type) : t('remind.choose');


/** PET TYPES */

const PET_TYPE_KEY = {
  dog: 'options.species.dog',
  cat: 'options.species.cat',
  rabbit: 'options.species.rabbit',
  parrot: 'options.species.parrot',
  hamster: 'options.species.hamster',  
  other: 'options.species.other',
};

// Helper to capitalize first letter
const capitalize = (str) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const getPetTypeLabel = (type, t) => {
  if (!type) return '';
  
  // If it's a predefined type, use translation
  if (PET_TYPE_KEY[type]) {
    return t(PET_TYPE_KEY[type]);
  }
  
  // Otherwise, it's a custom type - return capitalized original value
  return capitalize(type);
};


/** PET GENDERS */

const PET_GENDER_KEY = {
  girl: 'options.gender.female',
  boy: 'options.gender.male',
};

export const getPetGenderLabel = (gender, t) =>
  gender ? t(PET_GENDER_KEY[gender] || 'options.gender.female', gender) : '';


/** BREEDS */

// Utility to create a slug from breed name
const breedSlug = (name) =>
  String(name)
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '') 
    .replace(/[^a-zA-Z0-9]+/g, ' ')                  
    .trim()
    .replace(/\s+/g, '_')                            
    .toLowerCase();

// Generate the i18n key for a given pet type and breed name
const breedKey = (petType, breedName) =>
  `${petType}.${breedSlug(breedName)}`;

// Get the translated label for a breed, with fallback to the original name
export const getBreedLabel = (petType, breedName, t) =>
  breedName ? t(breedKey(petType, breedName), breedName) : '';

// Specific getters for dog and cat breeds
export const getDogBreedLabel  = (breedName, t) => getBreedLabel('dog', breedName, t);
export const getCatBreedLabel  = (breedName, t) => getBreedLabel('cat', breedName, t);

// Build options for a select dropdown from breed names
export const buildBreedOptions = (petType, breeds = [], t) =>
  breeds.map((b) => ({ value: b, label: getBreedLabel(petType, b, t) }));

// Filter breed options based on a search query
export const filterBreedOptions = (options, query) => {
  const q = (query || '').trim().toLowerCase();
  if (!q) return options;
  return options.filter(({ label, value }) =>
    label.toLowerCase().includes(q) || String(value).toLowerCase().includes(q)
  );
};
 
/** --- */

// Utility to pick the appropriate language from a map with fallback
export const pickLang = (map, lang, fallback = 'en') => {
  if (!map || typeof map !== 'object') return '';
  return map[lang] ?? map[fallback] ?? Object.values(map)[0] ?? '';
};

/** Only the requested locale — no fallback (for article visibility). */
export const pickLangStrict = (map, lang) => {
  if (!map || typeof map !== 'object') return '';
  const v = map[lang];
  return typeof v === 'string' ? v.trim() : '';
};


